import { create } from "zustand";
import { persist } from "zustand/middleware";

export type MapStyleName = "standard" | "standard-satellite";
export type MapLightPreset = "dawn" | "day" | "dusk" | "night";

interface MapViewPrefsState {
  mapStyle: MapStyleName;
  showTransitLabels: boolean;
  showPointOfInterestLabels: boolean;
  showPlaceLabels: boolean;
  showRoadLabels: boolean;
  show3dObjects: boolean;
  lightPreset: MapLightPreset;
  terrainEnabled: boolean;

  setMapStyle: (style: MapStyleName) => void;
  setShowTransitLabels: (value: boolean) => void;
  setShowPointOfInterestLabels: (value: boolean) => void;
  setShowPlaceLabels: (value: boolean) => void;
  setShowRoadLabels: (value: boolean) => void;
  setShow3dObjects: (value: boolean) => void;
  setLightPreset: (preset: MapLightPreset) => void;
  setTerrainEnabled: (value: boolean) => void;
}

export const useMapViewPrefsStore = create<MapViewPrefsState>()(
  persist(
    (set) => ({
      mapStyle: "standard",
      showTransitLabels: true,
      showPointOfInterestLabels: true,
      showPlaceLabels: true,
      showRoadLabels: true,
      show3dObjects: true,
      lightPreset: "day",
      terrainEnabled: false,

      setMapStyle: (mapStyle) => set({ mapStyle }),
      setShowTransitLabels: (showTransitLabels) => set({ showTransitLabels }),
      setShowPointOfInterestLabels: (showPointOfInterestLabels) =>
        set({ showPointOfInterestLabels }),
      setShowPlaceLabels: (showPlaceLabels) => set({ showPlaceLabels }),
      setShowRoadLabels: (showRoadLabels) => set({ showRoadLabels }),
      setShow3dObjects: (show3dObjects) => set({ show3dObjects }),
      setLightPreset: (lightPreset) => set({ lightPreset }),
      setTerrainEnabled: (terrainEnabled) => set({ terrainEnabled }),
    }),
    { name: "map-view-prefs" },
  ),
);
